// extracted by mini-css-extract-plugin
export var content = "NewsletterTwoColumns-module--content--s4L2e";
export var form = "NewsletterTwoColumns-module--form--IfBKq";
export var imageContainer = "NewsletterTwoColumns-module--imageContainer--5b3mE";
export var label = "NewsletterTwoColumns-module--label--SKMIM";
export var subtitle = "NewsletterTwoColumns-module--subtitle--+yWTc";
export var title = "NewsletterTwoColumns-module--title--n8nbn";
export var wrapper = "NewsletterTwoColumns-module--wrapper--Jb8eo";